var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('v-list',_vm._l((_vm.value.layout),function(item,index){return _c('v-list-item',{key:index},[_c(item.children ? 'category' : 'resource',{tag:"component",attrs:{"value":item}})],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }